var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyRegular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61_4360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3855 4.03488L20.7536 1.40305C20.498 1.14485 20.1456 1 19.7804 1H12.7507C11.2318 1 10.0007 2.23148 10.0007 3.75L10.0015 14.75C10.0394 16.2711 11.2726 17.5 12.7894 17.5H21.0394C22.5519 17.5 23.7894 16.2625 23.7894 14.75V5.00684C23.7894 4.64246 23.6433 4.2927 23.3855 4.03488ZM21.7269 14.75C21.7269 15.1297 21.419 15.4375 21.0394 15.4375H12.7507C12.3709 15.4375 12.0632 15.1297 12.0632 14.75V3.75559C12.0632 3.37591 12.371 3.06809 12.7507 3.06809H18.2507L18.2894 5.125C18.2894 5.88426 18.9051 6.5 19.6644 6.5H21.6882V14.75H21.7269ZM13.4769 20.25C13.4769 20.6297 13.169 20.9375 12.7894 20.9375H4.5007C4.12094 20.9375 3.8132 20.6297 3.8132 20.25L3.85101 9.2543C3.85101 8.87463 4.15884 8.5668 4.53851 8.5668H8.66437V6.5H4.53894C3.02 6.5 1.78894 7.73105 1.78894 9.25L1.78936 20.25C1.78946 21.7668 3.02085 23 4.53937 23H12.7894C14.3019 23 15.5394 21.7625 15.5394 20.25V18.875H13.5155L13.4769 20.25Z",
    fill: "#7A7A7A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61_4360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(1.78955 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyRegular);
export default __webpack_public_path__ + "static/media/copy-regular.ac95eaff93c35d9b6a44b8cf00d7875c.svg";
export { ForwardRef as ReactComponent };